import Chart from 'chart.js';

function getCanvasCtx(width, height) {
  const canvas = document.createElement('canvas');
  canvas.setAttribute('style', `width: ${width}px; height: ${height}px;`);
  canvas.width = width;
  canvas.height = height;
  return canvas.getContext('2d');
}

const outputOptions = {
  devicePixelRatio: 1,
  responsive: false,
  maintainAspectRatio: false,
  animation: {duration: 0},
};

function getChartOptions(params) {
  return {
    ...params,
    options: {
      ...params.options,
      legend: {
        ...params.options.legend,
        labels: {
          fontSize: 8,
          filter: function (legendItem, data) {
            // filter out items without label (e.g. min/max datasets)
            return !!legendItem.text;
          },
        },
      },
      ...outputOptions,
    },
    plugins: [{
      // commented as nneded to generate transparent image for dark theme support
      // beforeDraw: function (chartInstance) {
      //   var ctx = chartInstance.chart.ctx;
      //   ctx.fillStyle = 'white';
      //   ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      // }
    }],
  };
}

/**
 * Returns base64-encoded chart image
 * @param params
 * @param width desired image width
 * @param height desired image height
 * @param addLegendHeight whether extend height of image with legend height (needed for charts with manu datasets)
 * @returns {*}
 */
export function getChartImage(params, width, height, addLegendHeight = true) {
  const options = getChartOptions(params);
  let chart = new Chart(getCanvasCtx(width, height), options);
  // increase the canvas height so a high legend won't shrink the chart area
  if (addLegendHeight) {
    height += chart.legend.height;
    chart.destroy();
    chart = new Chart(getCanvasCtx(width, height), options);
  }
  const image = chart.toBase64Image();
  chart.destroy();
  return image;
}

/**
 * Convert base64-encoded binary data to blob object
 *
 * @param b64Data string containing base64-encoded data
 * @param contentType content type
 * @param sliceSize chunk size
 * @return {Blob}
 */
export function base64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {type: contentType});
}
